import { KnownBrandCode } from "shared"
import santander from "./contact.santander.json"

export function useContact(brandCode: KnownBrandCode){
    return santander;
}